import { Component } from '@angular/core';

@Component({
  selector: 'app-error-401',
  template: `
    <error-code
      [code]="'401'"
      [title]="'Unauthorized!'"
      [message]="'You do not have permission to access this site.'"
    ></error-code>
  `,
})
export class Error401Component {}